export default __webpack_public_path__ + "static/upicon-43be16c923fee65581d0e2efbe3746a2.png";